export const isValid8601Date = /[+-]?\d{4}(-[01]\d(-[0-3]\d(T[0-2]\d:[0-5]\d:?([0-5]\d(\.\d+)?)?[+-][0-2]\d:[0-5]\dZ?)?)?)?/ // https://regexr.com/3e0lh
export const formatOptions = {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit'
}
